// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%239ca3af%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27m6 9 6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&family=Manrope:wght@400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   EDGAR INSIGHTS - MODERN DESIGN SYSTEM
   ============================================ */

/* CSS Variables */
:root {
  /* Colors - Dark Theme */
  --gray-50: #f9fafb;
  --gray-100: #f3f4f6;
  --gray-200: #e5e7eb;
  --gray-300: #d1d5db;
  --gray-400: #9ca3af;
  --gray-500: #6b7280;
  --gray-600: #4b5563;
  --gray-700: #374151;
  --gray-800: #1f2937;
  --gray-900: #111827;
  --gray-950: #030712;
  
  /* Brand Colors */
  --gold-400: #fbbf24;
  --gold-500: #f59e0b;
  --gold-600: #d97706;
  
  --green-400: #34d399;
  --green-500: #10b981;
  --green-600: #059669;
  
  --red-400: #f87171;
  --red-500: #ef4444;
  --red-600: #dc2626;
  
  --blue-400: #60a5fa;
  --blue-500: #3b82f6;
  --blue-600: #2563eb;
  
  /* Background System */
  --bg-primary: #0a0e1a;
  --bg-secondary: #0f1419;
  --bg-tertiary: #1a1f2e;
  --bg-elevated: #232938;
  
  /* Border Colors */
  --border-primary: rgba(255, 255, 255, 0.08);
  --border-secondary: rgba(255, 255, 255, 0.12);
  --border-accent: rgba(251, 191, 36, 0.2);
  
  /* Text Colors */
  --text-primary: #f9fafb;
  --text-secondary: #d1d5db;
  --text-tertiary: #9ca3af;
  --text-muted: #6b7280;
  
  /* Spacing Scale */
  --space-1: 0.25rem;
  --space-2: 0.5rem;
  --space-3: 0.75rem;
  --space-4: 1rem;
  --space-5: 1.25rem;
  --space-6: 1.5rem;
  --space-8: 2rem;
  --space-10: 2.5rem;
  --space-12: 3rem;
  --space-16: 4rem;
  
  /* Border Radius */
  --radius-sm: 0.375rem;
  --radius-md: 0.5rem;
  --radius-lg: 0.75rem;
  --radius-xl: 1rem;
  --radius-full: 9999px;
  
  /* Shadows */
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.4), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.5), 0 4px 6px -2px rgba(0, 0, 0, 0.3);
  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.5), 0 10px 10px -5px rgba(0, 0, 0, 0.3);
  
  /* Typography */
  --font-display: 'Space Grotesk', 'Manrope', -apple-system, 'Segoe UI', 'Helvetica Neue', sans-serif;
  --font-sans: 'Manrope', -apple-system, 'Segoe UI', 'Helvetica Neue', sans-serif;
  --font-mono: ui-monospace, 'SF Mono', 'Cascadia Code', 'Source Code Pro', monospace;

  /* Accent */
  --accent-cyan: #67e8f9;
  --accent-emerald: #22c55e;
  --grid-line: rgba(255, 255, 255, 0.04);
  --glass: rgba(255, 255, 255, 0.04);
  --glow-amber: 0 16px 70px rgba(245, 158, 11, 0.28);
  --glow-cyan: 0 16px 70px rgba(103, 232, 249, 0.22);
  
  /* Transitions */
  --transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-base: 200ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-slow: 300ms cubic-bezier(0.4, 0, 0.2, 1);
}

/* ============================================
   BASE STYLES
   ============================================ */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-size-adjust: 100%;
  scroll-behavior: smooth;
}

body {
  font-family: var(--font-sans);
  background: var(--bg-primary);
  color: var(--text-secondary);
  line-height: 1.6;
  overflow-x: hidden;
}

h1, h2, h3, h4 {
  font-family: var(--font-display);
  letter-spacing: -0.01em;
  color: var(--text-primary);
}

p {
  color: var(--text-secondary);
}

/* ============================================
   LAYOUT
   ============================================ */

.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.container {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 var(--space-6);
}

.main {
  flex: 1 1;
  padding: var(--space-8) 0;
}

/* ============================================
   AUTHENTICATION VIEW
   ============================================ */

.auth-view {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-6);
  background: 
    radial-gradient(ellipse 1000px 800px at 30% 20%, rgba(251, 191, 36, 0.08), transparent 50%),
    radial-gradient(ellipse 800px 600px at 70% 80%, rgba(59, 130, 246, 0.06), transparent 50%),
    var(--bg-primary);
}

.auth-container {
  width: 100%;
  max-width: 440px;
}

.auth-brand {
  text-align: center;
  margin-bottom: var(--space-8);
}

.brand-icon {
  display: inline-flex;
  margin-bottom: var(--space-4);
}

.brand-icon-frame {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
  align-items: center;
  justify-content: center;
  padding: 2px;
  flex-shrink: 0;
  box-shadow: 0 0 0 2px rgba(251, 191, 36, 0.3);
}

.brand-icon-frame img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.brand-icon-auth.brand-icon-frame {
  width: 80px;
  height: 80px;
  border-radius: 18px;
  padding: 4px;
  margin-bottom: var(--space-4);
}

.auth-brand h1 {
  font-size: 1.875rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: var(--space-2);
  letter-spacing: -0.02em;
}

.auth-brand p {
  color: var(--text-tertiary);
  font-size: 0.9375rem;
}

.auth-card {
  background: var(--bg-elevated);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-xl);
  padding: var(--space-8);
  box-shadow: var(--shadow-xl);
}

.auth-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-2);
  padding: var(--space-1);
  background: var(--bg-tertiary);
  border-radius: var(--radius-md);
  margin-bottom: var(--space-6);
}

.auth-tabs button {
  padding: var(--space-2) var(--space-4);
  background: transparent;
  border: none;
  border-radius: var(--radius-sm);
  color: var(--text-tertiary);
  font-weight: 600;
  font-size: 0.9375rem;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.auth-tabs button.active {
  background: var(--bg-primary);
  color: var(--text-primary);
  box-shadow: var(--shadow-sm);
}

.auth-alert {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-4);
  border-radius: var(--radius-md);
  margin-bottom: var(--space-6);
  font-size: 0.875rem;
  line-height: 1.5;
  min-width: 0;
}

.auth-alert svg {
  flex-shrink: 0;
  margin-top: 2px;
}

.auth-alert .auth-alert-text {
  min-width: 0;
  overflow-wrap: break-word;
  word-break: break-all;
}

.auth-alert.error {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #fca5a5;
}

.auth-alert.success {
  background: rgba(16, 185, 129, 0.1);
  border: 1px solid rgba(16, 185, 129, 0.3);
  color: #6ee7b7;
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.form-field label {
  color: var(--text-secondary);
  font-size: 0.875rem;
  font-weight: 500;
}

.form-field input,
.form-field select {
  width: 100%;
  padding: var(--space-3) var(--space-4);
  background: var(--bg-tertiary);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-md);
  color: var(--text-primary);
  font-size: 0.9375rem;
  transition: all var(--transition-fast);
}

.form-field input:focus,
.form-field select:focus {
  outline: none;
  border-color: var(--gold-500);
  box-shadow: 0 0 0 3px rgba(251, 191, 36, 0.1);
}

.form-field input::placeholder {
  color: var(--text-muted);
}

.form-actions {
  display: flex;
  gap: var(--space-3);
  margin-top: var(--space-2);
}

.btn-primary {
  flex: 1 1;
  padding: 0.875rem 1.5rem;
  background: var(--gold-400);
  border: none;
  border-radius: 12px;
  color: var(--gray-950);
  font-weight: 600;
  font-size: 0.9375rem;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.btn-primary:hover:not(:disabled) {
  background: var(--gold-500);
  box-shadow: 0 4px 14px rgba(251, 191, 36, 0.35);
  transform: translateY(-1px);
}

.btn-primary:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-secondary {
  flex: 1 1;
  padding: 0.875rem 1.5rem;
  background: transparent;
  border: 1px solid var(--border-secondary);
  border-radius: 12px;
  color: var(--text-primary);
  font-weight: 600;
  font-size: 0.9375rem;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, transform 0.15s ease;
}

.btn-secondary:hover:not(:disabled) {
  background: var(--bg-tertiary);
  border-color: var(--gold-500);
  color: var(--gold-400);
  transform: translateY(-1px);
}

.btn-secondary:active:not(:disabled) {
  transform: translateY(0);
}

.btn-secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.auth-footer {
  margin-top: var(--space-6);
  padding-top: var(--space-6);
  border-top: 1px solid var(--border-primary);
  display: flex;
  justify-content: center;
  gap: var(--space-6);
}

.link-btn {
  background: none;
  border: none;
  color: var(--gold-400);
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: color var(--transition-fast);
}

.link-btn:hover {
  color: var(--gold-500);
  text-decoration: underline;
}

/* ============================================
   HEADER
   ============================================ */

.header {
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-primary);
  backdrop-filter: blur(12px);
  position: sticky;
  top: 0;
  z-index: 50;
}

.header .brand-icon {
  margin-bottom: 0;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-4) 0;
}

.brand {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.brand h1 {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: -0.01em;
  margin-bottom: 2px;
}

.brand p {
  font-size: 0.75rem;
  color: var(--text-tertiary);
}

.btn-ghost {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-4);
  background: transparent;
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-full);
  color: var(--text-secondary);
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.btn-ghost:hover {
  background: var(--bg-tertiary);
  border-color: var(--border-secondary);
  color: var(--text-primary);
}

.btn-ghost svg {
  opacity: 0.8;
}

/* ============================================
   STATS GRID
   ============================================ */

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: var(--space-4);
  margin-bottom: var(--space-8);
}

.stat-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-lg);
  padding: var(--space-5);
  transition: all var(--transition-fast);
}

.stat-card:hover {
  border-color: var(--border-secondary);
  transform: translateY(-2px);
}

.stat-label {
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: var(--space-2);
}

.stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: var(--radius-full);
  animation: pulse 2s ease-in-out infinite;
}

.status-running .status-dot {
  background: var(--green-500);
}

.status-stopped .status-dot {
  background: var(--red-500);
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

/* ============================================
   FILTERS
   ============================================ */

.filter-section {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-lg);
  padding: var(--space-6);
  margin-bottom: var(--space-8);
}

.filter-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: var(--space-4);
}

.filter-field {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.filter-field label {
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.filter-field input,
.filter-field select {
  width: 100%;
  padding: var(--space-3) var(--space-4);
  background: var(--bg-tertiary);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-lg);
  color: var(--text-primary);
  font-size: 0.9375rem;
  font-weight: 500;
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast), background var(--transition-fast);
}

.filter-field input:hover,
.filter-field select:hover {
  border-color: var(--border-secondary);
  background: var(--bg-secondary);
}

.filter-field input:focus,
.filter-field select:focus {
  outline: none;
  border-color: var(--gold-500);
  box-shadow: 0 0 0 3px rgba(251, 191, 36, 0.12);
  background: var(--bg-secondary);
}

.filter-field select {
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right var(--space-4) center;
  padding-right: var(--space-10);
}

.filter-field-checkbox {
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.filter-field-checkbox label {
  order: 2;
  margin-left: var(--space-2);
  text-transform: none;
  letter-spacing: 0;
}
.filter-field-checkbox input[type="checkbox"] {
  width: auto;
  order: 1;
  accent-color: var(--gold-500);
  cursor: pointer;
}

.ticker-search-wrapper {
  position: relative;
}

.search-icon {
  position: absolute;
  left: var(--space-4);
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted);
  pointer-events: none;
}

.ticker-search-wrapper input {
  padding-left: var(--space-10);
}

.dropdown {
  position: absolute;
  top: calc(100% + var(--space-2));
  left: 0;
  right: 0;
  background: var(--bg-elevated);
  border: 1px solid var(--border-secondary);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  max-height: 300px;
  overflow-y: auto;
  z-index: 100;
}

.dropdown-item {
  width: 100%;
  padding: var(--space-3) var(--space-4);
  background: transparent;
  border: none;
  border-bottom: 1px solid var(--border-primary);
  text-align: left;
  cursor: pointer;
  transition: background var(--transition-fast), color var(--transition-fast);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-4);
  font-size: 0.9375rem;
}

.dropdown-item:last-child {
  border-bottom: none;
}

.dropdown-item:hover {
  background: rgba(251, 191, 36, 0.08);
}

.dropdown-item:hover .ticker-symbol {
  color: var(--gold-400);
}

.ticker-symbol {
  font-weight: 700;
  color: var(--gold-400);
  font-size: 0.9375rem;
}

.ticker-name {
  color: var(--text-tertiary);
  font-size: 0.875rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.filter-tag {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-4);
  background: rgba(251, 191, 36, 0.1);
  border: 1px solid rgba(251, 191, 36, 0.3);
  border-radius: var(--radius-full);
  color: var(--gold-400);
  font-size: 0.875rem;
  font-weight: 600;
  margin-top: var(--space-2);
}

.filter-tag button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-left: var(--space-1);
  background: transparent;
  border: none;
  border-radius: 50%;
  color: var(--text-muted);
  font-size: 1.125rem;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  transition: color var(--transition-fast), background var(--transition-fast);
}

.filter-tag button:hover {
  color: var(--red-500);
  background: rgba(239, 68, 68, 0.15);
}

/* ============================================
   CONTENT SECTIONS
   ============================================ */

.content-section {
  margin-top: var(--space-6);
}

.section-header {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  margin-bottom: var(--space-6);
}

.section-header h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: -0.02em;
}

.count-badge {
  padding: var(--space-1) var(--space-3);
  background: var(--bg-tertiary);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-full);
  color: var(--text-tertiary);
  font-size: 0.875rem;
  font-weight: 600;
}

/* ============================================
   ALERTS
   ============================================ */

.alert {
  display: flex;
  align-items: flex-start;
  gap: var(--space-4);
  padding: var(--space-4);
  border-radius: var(--radius-lg);
  margin-bottom: var(--space-6);
}

.alert svg {
  flex-shrink: 0;
  margin-top: 2px;
}

.alert-error {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #fca5a5;
}

.alert strong {
  display: block;
  color: var(--text-primary);
  margin-bottom: var(--space-1);
  font-weight: 600;
}

.alert p {
  font-size: 0.875rem;
  line-height: 1.5;
  margin: 0;
}

.btn-sm {
  padding: var(--space-2) var(--space-4);
  background: rgba(239, 68, 68, 0.2);
  border: 1px solid rgba(239, 68, 68, 0.4);
  border-radius: var(--radius-md);
  color: #fca5a5;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-fast);
  margin-left: auto;
}

.btn-sm:hover {
  background: rgba(239, 68, 68, 0.3);
}

/* ============================================
   STATES
   ============================================ */

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-16) var(--space-6);
  text-align: center;
}

.spinner-large {
  width: 48px;
  height: 48px;
  border: 4px solid var(--bg-tertiary);
  border-top-color: var(--gold-500);
  border-radius: var(--radius-full);
  animation: spin 1s linear infinite;
  margin-bottom: var(--space-4);
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.loading-state p {
  color: var(--text-tertiary);
  font-size: 0.9375rem;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-16) var(--space-6);
  text-align: center;
}

.empty-state svg {
  color: var(--text-muted);
  margin-bottom: var(--space-6);
  opacity: 0.5;
}

.empty-state h3 {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: var(--space-2);
}

.empty-state p {
  color: var(--text-tertiary);
  font-size: 0.9375rem;
}

/* ============================================
   SIGNAL CARDS
   ============================================ */

.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: var(--space-6);
}

.signal-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-lg);
  overflow: hidden;
  transition: all var(--transition-base);
}

.signal-card:hover {
  border-color: var(--border-secondary);
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
}

.signal-card.has-trade {
  border-color: var(--border-accent);
  cursor: pointer;
}

.signal-card.has-trade.trade-decision-yes {
  box-shadow: 0 0 0 1px rgba(16, 185, 129, 0.4), 0 0 20px rgba(16, 185, 129, 0.15);
}
.signal-card.has-trade.trade-decision-yes:hover {
  box-shadow: 0 0 0 1px rgba(16, 185, 129, 0.5), 0 0 24px rgba(16, 185, 129, 0.25);
}

.signal-card.has-trade.trade-decision-no {
  box-shadow: 0 0 0 1px rgba(255, 69, 0, 0.4), 0 0 20px rgba(255, 69, 0, 0.15);
}
.signal-card.has-trade.trade-decision-no:hover {
  box-shadow: 0 0 0 1px rgba(255, 69, 0, 0.5), 0 0 24px rgba(255, 69, 0, 0.25);
}

.signal-card.expanded {
  grid-column: 1 / -1;
}

.card-main {
  padding: var(--space-6);
}

.card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
  margin-bottom: var(--space-5);
}

.ticker-info h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--gold-400);
  letter-spacing: -0.01em;
  margin-bottom: var(--space-1);
}

.ticker-info p {
  font-size: 0.875rem;
  color: var(--text-tertiary);
  line-height: 1.4;
}

.signal-badge {
  padding: var(--space-2) var(--space-4);
  border-radius: var(--radius-full);
  font-size: 0.8125rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
}

.signal-buy {
  background: rgba(16, 185, 129, 0.15);
  color: var(--green-400);
  border: 1px solid rgba(16, 185, 129, 0.3);
}

.signal-sell {
  background: rgba(239, 68, 68, 0.15);
  color: var(--red-400);
  border: 1px solid rgba(239, 68, 68, 0.3);
}

.signal-hold {
  background: rgba(251, 191, 36, 0.15);
  color: var(--gold-400);
  border: 1px solid rgba(251, 191, 36, 0.3);
}

.card-metrics {
  display: grid;
  gap: var(--space-4);
  margin-bottom: var(--space-5);
  padding-bottom: var(--space-5);
  border-bottom: 1px solid var(--border-primary);
}

.metric {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-4);
}

.metric-label {
  font-size: 0.8125rem;
  color: var(--text-tertiary);
  font-weight: 500;
}

.metric-value {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--text-primary);
}

.confidence-bar {
  width: 120px;
  height: 6px;
  background: var(--bg-tertiary);
  border-radius: var(--radius-full);
  overflow: hidden;
}

.confidence-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--gold-500), var(--gold-400));
  border-radius: var(--radius-full);
  transition: width var(--transition-slow);
}

.sentiment-badge {
  padding: var(--space-1) var(--space-3);
  border-radius: var(--radius-full);
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.sentiment-bullish {
  background: rgba(16, 185, 129, 0.15);
  color: var(--green-400);
}

.sentiment-bearish {
  background: rgba(239, 68, 68, 0.15);
  color: var(--red-400);
}

.sentiment-neutral {
  background: rgba(251, 191, 36, 0.15);
  color: var(--gold-400);
}

.key-insights {
  margin-bottom: var(--space-5);
}

.key-insights h4 {
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: var(--space-3);
}

.key-insights ul {
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.key-insights li {
  position: relative;
  padding-left: var(--space-5);
  font-size: 0.875rem;
  line-height: 1.6;
  color: var(--text-tertiary);
}

.key-insights li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 8px;
  width: 6px;
  height: 6px;
  background: var(--gold-500);
  border-radius: var(--radius-full);
}

.card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding-top: var(--space-4);
  border-top: 1px solid var(--border-primary);
}

.meta {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  flex-wrap: wrap;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  font-size: 0.8125rem;
  color: var(--text-muted);
}

.meta-item svg {
  opacity: 0.6;
}

.expand-trigger {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-4);
  background: var(--bg-tertiary);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-full);
  color: var(--text-secondary);
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-fast);
  white-space: nowrap;
}

.expand-trigger:hover {
  background: var(--bg-elevated);
  border-color: var(--border-accent);
  color: var(--gold-400);
}

.expand-trigger svg {
  transition: transform var(--transition-base);
}

.card-expanded {
  background: var(--bg-tertiary);
  border-top: 1px solid var(--border-primary);
  padding: var(--space-6);
}

.expanded-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--space-6);
}

.info-section h4 {
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: var(--space-4);
}

.info-section dl {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.info-section dl > div {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: var(--space-4);
  align-items: start;
  padding-bottom: var(--space-4);
  border-bottom: 1px solid var(--border-primary);
}

.info-section dl > div:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.info-section dt {
  font-size: 0.8125rem;
  color: var(--text-muted);
  font-weight: 500;
}

.info-section dd {
  font-size: 0.875rem;
  color: var(--text-secondary);
  margin: 0;
  word-break: break-word;
}

.info-section a {
  color: var(--gold-400);
  text-decoration: none;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  transition: color var(--transition-fast);
}

.info-section a:hover {
  color: var(--gold-500);
  text-decoration: underline;
}

.info-section a svg {
  opacity: 0.7;
}

.badge {
  display: inline-block;
  padding: var(--space-1) var(--space-3);
  background: var(--bg-elevated);
  border: 1px solid var(--border-secondary);
  border-radius: var(--radius-full);
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.text-muted {
  color: var(--text-muted);
}

.text-mono {
  font-family: var(--font-mono);
  font-size: 0.8125rem;
}

.trade-events-list {
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 0.8125rem;
}
.trade-events-list li {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--space-2);
  padding: var(--space-2) 0;
  border-bottom: 1px solid var(--border-secondary);
}
.trade-events-list li:last-child {
  border-bottom: none;
}
.trade-events-list .event-type {
  font-weight: 600;
  color: var(--text-primary);
  min-width: 8rem;
}
.trade-events-list .event-message {
  color: var(--text-secondary);
  flex: 1 1;
}
.trade-events-list .event-time {
  color: var(--text-muted);
  font-size: 0.75rem;
}
.info-section .trade-reasoning {
  white-space: pre-wrap;
  max-height: 8rem;
  overflow-y: auto;
}

.trade-reasoning-full {
  grid-column: 1 / -1;
  margin-top: var(--space-6);
  padding: var(--space-5);
  background: var(--bg-elevated);
  border-radius: var(--radius-md);
  border: 1px solid var(--border-secondary);
}
.trade-reasoning-full p {
  margin: 0;
  font-size: 0.9375rem;
  line-height: 1.65;
  color: var(--text-secondary);
  white-space: pre-wrap;
}

.trade-details-block {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  padding: var(--space-2) 0 var(--space-2) var(--space-5);
}
.trade-details-block.trade-decision-yes {
  border-left: 3px solid #10b981;
  margin-left: 0;
}
.trade-details-block.trade-decision-no {
  border-left: 3px solid #ff4500;
  margin-left: 0;
}
.trade-details-block .info-section {
  margin-bottom: 0;
}
.trade-details-block .info-section h4 {
  margin-bottom: var(--space-5);
}
.trade-details-block .info-section dl {
  gap: var(--space-4);
}
.trade-details-block .info-section dl > div {
  padding-bottom: var(--space-4);
}
.trade-details-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-8);
  align-items: start;
}
.trade-details-col {
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  min-width: 0;
}
.trade-details-row:not(:has(.trade-details-left .info-section)) .trade-details-right {
  grid-column: 1 / -1;
}

.trade-details-block .trade-events-list {
  margin-top: var(--space-2);
}
.trade-details-block .trade-events-list li {
  padding: var(--space-3) 0;
}

@media (max-width: 700px) {
  .trade-details-row {
    grid-template-columns: 1fr;
  }
}

/* Trade detail modal (pop-out viewbox) */
.trade-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: var(--space-6);
  animation: fadeIn 0.2s ease-out;
}

.trade-modal-viewbox {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-lg);
  max-width: 640px;
  width: 100%;
  max-height: 90vh;
  overflow-x: hidden;
  overflow-y: auto;
  box-shadow: var(--shadow-xl);
  animation: slideUp 0.25s ease-out;
}

@media (min-width: 880px) {
  .trade-modal-viewbox {
    max-width: 900px;
  }
}

.trade-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-5) var(--space-6);
  border-bottom: 1px solid var(--border-primary);
  position: sticky;
  top: 0;
  background: var(--bg-secondary);
  z-index: 1;
}

.trade-modal-header h2 {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--gold-400);
  margin: 0;
}

.trade-modal-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  background: var(--bg-tertiary);
  border-radius: 50%;
  color: var(--text-muted);
  cursor: pointer;
  transition: color var(--transition-fast), background var(--transition-fast), transform var(--transition-fast);
}

.trade-modal-close:hover {
  color: var(--text-primary);
  background: var(--border-secondary);
  transform: scale(1.05);
}

.trade-modal-close:active {
  transform: scale(0.98);
}

.trade-modal-body {
  padding: var(--space-8);
}
.trade-modal-body .expanded-grid {
  gap: var(--space-8);
}
.trade-modal-body .info-section h4 {
  margin-bottom: var(--space-5);
}
.trade-modal-body .info-section dl > div {
  padding-bottom: var(--space-4);
  gap: var(--space-4);
}
.trade-modal-body .info-section:first-of-type dl > div {
  padding-bottom: var(--space-4);
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card-click-hint {
  font-size: 0.75rem;
  color: var(--text-muted);
  margin-left: auto;
}

.alpaca-order-link {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  color: var(--gold-400);
  text-decoration: none;
  font-family: var(--font-mono);
  font-size: 0.8125rem;
}
.alpaca-order-link:hover {
  color: var(--gold-500);
  text-decoration: underline;
}
.alpaca-order-link svg {
  opacity: 0.8;
}

/* ============================================
   LANDING PAGE
   ============================================ */

.landing {
  position: relative;
  min-height: 100vh;
  color: var(--text-primary);
  background:
    radial-gradient(1200px 700px at 12% 12%, rgba(103, 232, 249, 0.08), transparent 40%),
    radial-gradient(900px 600px at 78% 8%, rgba(245, 158, 11, 0.12), transparent 40%),
    linear-gradient(180deg, rgba(15, 20, 25, 0.94), rgba(10, 14, 26, 0.98));
  overflow: hidden;
}

.landing::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
    linear-gradient(90deg, var(--grid-line) 1px, transparent 1px) 0 0 / 80px 80px,
    linear-gradient(0deg, var(--grid-line) 1px, transparent 1px) 0 0 / 80px 80px;
  opacity: 0.45;
  pointer-events: none;
}

.landing::after {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(650px 650px at 65% 35%, rgba(255, 255, 255, 0.06), transparent 60%);
  mix-blend-mode: screen;
  pointer-events: none;
}

.landing-inner {
  position: relative;
  z-index: 1;
}

.landing-header {
  position: sticky;
  top: 0;
  z-index: 60;
  background: rgba(10, 14, 26, 0.8);
  backdrop-filter: blur(16px);
  border-bottom: 1px solid var(--border-primary);
}

.landing-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-6);
  padding: var(--space-4) var(--space-4);
}

.nav-brand {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.nav-brand .brand-icon-frame {
  box-shadow: var(--glow-amber);
}

.nav-title {
  font-size: 1rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-tertiary);
}

.nav-links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-6);
  list-style: none;
  flex: 1 1;
}

.nav-links a {
  color: var(--text-secondary);
  text-decoration: none;
  font-weight: 600;
  font-size: 0.95rem;
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-full);
  transition: color var(--transition-fast), background var(--transition-fast);
}

.nav-links a:hover {
  color: var(--gold-400);
  background: rgba(255, 255, 255, 0.05);
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.pill {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-full);
  background: rgba(103, 232, 249, 0.12);
  color: var(--accent-cyan);
  border: 1px solid rgba(103, 232, 249, 0.3);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.cta-button {
  background: linear-gradient(120deg, var(--gold-400), var(--gold-500));
  color: #0b0f1a;
  border: 1px solid rgba(251, 191, 36, 0.45);
  border-radius: 14px;
  padding: var(--space-3) var(--space-5);
  font-weight: 700;
  font-size: 0.95rem;
  letter-spacing: 0.01em;
  cursor: pointer;
  box-shadow: var(--glow-amber);
  transition: transform var(--transition-fast), box-shadow var(--transition-fast), background var(--transition-fast);
}

.cta-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 30px rgba(251, 191, 36, 0.35);
}

.cta-button:active {
  transform: translateY(0);
}

.cta-secondary {
  background: rgba(255, 255, 255, 0.04);
  color: var(--text-primary);
  border: 1px solid var(--border-secondary);
  border-radius: 14px;
  padding: var(--space-3) var(--space-5);
  font-weight: 700;
  cursor: pointer;
  transition: background var(--transition-fast), border-color var(--transition-fast), color var(--transition-fast), transform var(--transition-fast);
}

.cta-secondary:hover {
  background: var(--bg-tertiary);
  border-color: var(--border-accent);
  color: var(--gold-400);
  transform: translateY(-1px);
}

.hero {
  position: relative;
  padding: var(--space-16) 0 var(--space-12);
  z-index: 1;
}

.hero-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: var(--space-10);
  align-items: center;
}

.hero-copy {
  max-width: 720px;
  display: grid;
  gap: var(--space-4);
}

.hero-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-full);
  border: 1px solid var(--border-secondary);
  background: rgba(255, 255, 255, 0.04);
  color: var(--text-tertiary);
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  width: fit-content;
}

.hero-title {
  font-size: clamp(2.4rem, 2.2vw + 1.2rem, 3.6rem);
  line-height: 1.05;
  color: var(--text-primary);
}

.hero-title span {
  color: var(--gold-400);
}

.hero-lede {
  font-size: 1.05rem;
  color: var(--text-secondary);
  max-width: 640px;
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  align-items: center;
}

.hero-footnote {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  color: var(--text-tertiary);
  font-size: 0.85rem;
}

.site-tagline {
  text-align: center;
  color: var(--text-tertiary);
  font-size: 0.85rem;
  margin-top: var(--space-2);
  margin-bottom: 0;
}

.disclaimer {
  margin-top: var(--space-1);
  text-align: center;
  font-size: 0.72rem;
  color: var(--text-quaternary, #7f8899);
  line-height: 1.4;
}

.hero-panel {
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.02));
  border: 1px solid var(--border-secondary);
  border-radius: 18px;
  padding: var(--space-6);
  box-shadow: var(--glow-cyan);
  position: relative;
  overflow: hidden;
}

.hero-panel::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(400px 400px at 80% 20%, rgba(103, 232, 249, 0.2), transparent 55%);
  pointer-events: none;
}

.hero-panel h3 {
  font-size: 1rem;
  color: var(--text-tertiary);
  margin-bottom: var(--space-3);
}

.hero-panel .panel-metric {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: var(--space-3) 0;
  border-bottom: 1px solid var(--border-primary);
}

.hero-panel .panel-metric:last-child {
  border-bottom: none;
}

.panel-metric strong {
  font-size: 1.4rem;
  color: var(--text-primary);
}

.panel-metric span {
  color: var(--text-tertiary);
  font-size: 0.9rem;
}

.hero-meter {
  margin-top: var(--space-4);
  position: relative;
  height: 12px;
  background: var(--bg-tertiary);
  border-radius: var(--radius-full);
  overflow: hidden;
}

.hero-meter-fill {
  width: 82%;
  height: 100%;
  background: linear-gradient(90deg, var(--gold-500), var(--accent-cyan));
  box-shadow: var(--glow-amber);
}

.hero-meter-label {
  position: absolute;
  top: 50%;
  right: var(--space-3);
  transform: translateY(-50%);
  font-size: 0.75rem;
  color: var(--text-primary);
  letter-spacing: 0.06em;
}

.hero-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: var(--space-3);
  margin-top: var(--space-5);
}

.hero-stat {
  padding: var(--space-4);
  background: var(--bg-secondary);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-secondary);
  display: grid;
  gap: var(--space-1);
  box-shadow: var(--shadow-md);
}

.hero-stat .label {
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-tertiary);
}

.hero-stat .value {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--text-primary);
}

.section {
  padding: var(--space-12) 0;
  position: relative;
  z-index: 1;
}

.section-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-6);
  margin-bottom: var(--space-6);
  flex-wrap: wrap;
}

.section-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-full);
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid var(--border-secondary);
  color: var(--text-tertiary);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 0.8rem;
}

.section-title {
  font-size: 2rem;
  margin-top: var(--space-2);
}

.section-description {
  max-width: 760px;
  color: var(--text-secondary);
  font-size: 1rem;
}

.about-grid,
.feature-grid,
.pricing-grid,
.blog-grid,
.faq-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: var(--space-5);
}

.about-card,
.feature-card,
.pricing-card,
.blog-card,
.faq-item {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-lg);
  padding: var(--space-5);
  position: relative;
  overflow: hidden;
  transition: transform var(--transition-fast), border-color var(--transition-fast), box-shadow var(--transition-fast);
}

.about-card:hover,
.feature-card:hover,
.pricing-card:hover,
.blog-card:hover,
.faq-item:hover {
  transform: translateY(-4px);
  border-color: var(--border-secondary);
  box-shadow: var(--shadow-lg);
}

.about-card h3 {
  margin-bottom: var(--space-2);
}

.about-card p {
  color: var(--text-secondary);
}

.feature-card {
  background: linear-gradient(150deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.01));
  border: 1px solid var(--border-secondary);
}

.feature-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(251, 191, 36, 0.12);
  color: var(--gold-400);
  margin-bottom: var(--space-3);
}

.feature-card ul {
  list-style: none;
  padding: 0;
  margin: var(--space-3) 0 0;
  display: grid;
  gap: var(--space-2);
}

.feature-card li {
  color: var(--text-secondary);
  font-size: 0.95rem;
  display: flex;
  gap: var(--space-2);
  align-items: baseline;
}

.feature-card li::before {
  content: '+';
  color: var(--accent-cyan);
  font-weight: 700;
}

.pricing-grid {
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
}

.pricing-card {
  background: linear-gradient(150deg, rgba(255, 255, 255, 0.02), rgba(103, 232, 249, 0.04));
  border: 1px solid var(--border-primary);
}

.pricing-card.recommended {
  border: 1px solid rgba(251, 191, 36, 0.6);
  box-shadow: var(--glow-amber);
}

.pricing-card .plan-label {
  display: none;
}

.pricing-card .price {
  font-size: 2.4rem;
  font-weight: 700;
  margin: var(--space-3) 0 var(--space-1);
  color: var(--text-primary);
}

.pricing-card .price small {
  font-size: 1rem;
  color: var(--text-tertiary);
  font-weight: 500;
}

.pricing-card .price-note {
  color: var(--text-tertiary);
  margin-bottom: var(--space-4);
}

.pricing-card .plan-features {
  list-style: none;
  padding: 0;
  margin: 0 0 var(--space-5);
  display: grid;
  gap: var(--space-2);
}

.pricing-card .plan-features li {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  color: var(--text-secondary);
  font-size: 0.95rem;
}

.pricing-card .plan-features li::before {
  content: '+';
  color: var(--gold-400);
  font-weight: 800;
}

.blog-card {
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0.01));
}

.blog-card .meta {
  display: flex;
  gap: var(--space-3);
  color: var(--text-tertiary);
  font-size: 0.85rem;
  margin-bottom: var(--space-2);
}

.blog-card h3 {
  margin-bottom: var(--space-2);
}

.blog-card a {
  color: var(--gold-400);
  font-weight: 700;
  text-decoration: none;
}

.blog-card a:hover {
  text-decoration: underline;
}

.faq-item {
  display: grid;
  gap: var(--space-2);
}

.faq-item h4 {
  margin: 0;
}

.faq-item p {
  margin: 0;
  color: var(--text-secondary);
}

.landing-footer {
  padding: var(--space-6) 0 var(--space-4);
  border-top: 1px solid var(--border-primary);
  margin-top: var(--space-3);
  color: var(--text-tertiary);
  font-size: 0.95rem;
}

/* Auth overlay */
.auth-overlay {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: grid;
  place-items: center;
  padding: var(--space-4);
}

.auth-overlay__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(6px);
}

.auth-overlay__panel {
  position: relative;
  width: min(920px, calc(100vw - 2rem));
  max-height: 92vh;
  overflow-y: auto;
  background: var(--bg-secondary);
  border: 1px solid var(--border-secondary);
  border-radius: 18px;
  box-shadow: var(--shadow-xl);
  z-index: 1;
  padding: var(--space-2) var(--space-2) var(--space-4);
}

.auth-overlay__close {
  position: absolute;
  top: var(--space-3);
  right: var(--space-3);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid var(--border-primary);
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform var(--transition-fast), background var(--transition-fast), color var(--transition-fast);
  z-index: 2;
}

.auth-overlay__close:hover {
  color: var(--gold-400);
  background: var(--bg-secondary);
  transform: translateY(-1px);
}

.auth-overlay .auth-view {
  min-height: auto;
  background: transparent;
  padding: var(--space-2);
}

.auth-overlay .auth-container {
  max-width: 640px;
  margin: 0 auto;
}

.auth-overlay .auth-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-secondary);
  box-shadow: var(--shadow-lg);
}

/* ============================================
   RESPONSIVE DESIGN
   ============================================ */

@media (max-width: 768px) {
  .container {
    padding: 0 var(--space-4);
  }
  
  .main {
    padding: var(--space-6) 0;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
  }
  
  .filter-grid {
    grid-template-columns: 1fr;
  }
  
  .cards-grid {
    grid-template-columns: 1fr;
  }
  
  .signal-card.expanded {
    grid-column: auto;
  }
  
  .expanded-grid {
    grid-template-columns: 1fr;
  }
  
  .auth-footer {
    flex-direction: column;
    gap: var(--space-3);
  }
  
  .brand h1 {
    font-size: 1.125rem;
  }
  
  .brand p {
    display: none;
  }
  
  .info-section dl > div {
    grid-template-columns: 1fr;
    gap: var(--space-1);
  }

  .landing-nav {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-3);
  }

  .nav-links {
    width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: var(--space-3);
  }

  .nav-actions {
    width: 100%;
    justify-content: flex-start;
  }

  .hero {
    padding: var(--space-12) 0 var(--space-8);
  }

  .hero-grid {
    grid-template-columns: 1fr;
  }

  .hero-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .cta-button,
  .cta-secondary {
    width: 100%;
    text-align: center;
  }

  .section-heading {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .header-content {
    flex-wrap: wrap;
  }
  
  .btn-ghost span {
    display: none;
  }
  
  .meta {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-2);
  }
  
  .card-footer {
    flex-direction: column;
    align-items: flex-start;
  }

  .nav-links {
    overflow-x: auto;
    width: 100%;
    padding-bottom: var(--space-2);
  }
  
  .nav-links a {
    white-space: nowrap;
  }
  
  .hero-panel {
    padding: var(--space-5);
  }
}

/* Accessibility */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

/* Print styles */
@media print {
  .header,
  .filter-section,
  .btn-primary,
  .btn-secondary,
  .btn-ghost,
  .expand-trigger {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;;iDAEiD;;AAEjD,kBAAkB;AAClB;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;;EAElB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;;EAEtB,kBAAkB;EAClB,2CAA2C;EAC3C,6CAA6C;EAC7C,wCAAwC;;EAExC,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;;EAErB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;;EAEhB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;;EAErB,YAAY;EACZ,2CAA2C;EAC3C,iFAAiF;EACjF,mFAAmF;EACnF,qFAAqF;;EAErF,eAAe;EACf,mGAAmG;EACnG,+EAA+E;EAC/E,mFAAmF;;EAEnF,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,sCAAsC;EACtC,kCAAkC;EAClC,kDAAkD;EAClD,kDAAkD;;EAElD,gBAAgB;EAChB,qDAAqD;EACrD,qDAAqD;EACrD,qDAAqD;AACvD;;AAEA;;iDAEiD;;AAEjD;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,yBAAyB;AAC3B;;AAEA;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB;;;qBAGmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,2BAA2B;EAC3B,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,sCAAsC;EACtC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;EAC/B,0BAA0B;EAC1B,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;;EAEE,aAAa;EACb,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,wBAAwB;EACxB,2BAA2B;EAC3B,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;EACf,4EAA4E;EAC5E,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,wBAAwB;EACxB,uBAAuB;EACvB,yCAAyC;EACzC,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;EACf,+FAA+F;AACjG;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,2CAA2C;EAC3C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;;iDAEiD;;AAEjD;EACE,+BAA+B;EAC/B,8CAA8C;EAC9C,2BAA2B;EAC3B,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,uBAAuB;EACvB,uCAAuC;EACvC,iCAAiC;EACjC,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;;iDAEiD;;AAEjD;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,sCAAsC;EACtC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;EAC/B,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,qHAAqH;AACvH;;AAEA;;EAEE,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;;EAEE,aAAa;EACb,6BAA6B;EAC7B,8CAA8C;EAC9C,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yDAAwQ;EACxQ,4BAA4B;EAC5B,gDAAgD;EAChD,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,QAAQ;EACR,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,OAAO;EACP,QAAQ;EACR,8BAA8B;EAC9B,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,uBAAuB;EACvB,YAAY;EACZ,8CAA8C;EAC9C,gBAAgB;EAChB,eAAe;EACf,2EAA2E;EAC3E,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,mCAAmC;EACnC,yCAAyC;EACzC,iCAAiC;EACjC,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,UAAU;EACV,2EAA2E;AAC7E;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;;iDAEiD;;AAEjD;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;EAC9B,uCAAuC;EACvC,iCAAiC;EACjC,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,wCAAwC;EACxC,+BAA+B;EAC/B,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,iCAAiC;EACjC,iCAAiC;EACjC,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,4DAA4D;EAC5D,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,+BAA+B;EAC/B,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,gFAAgF;AAClF;AACA;EACE,gFAAgF;AAClF;;AAEA;EACE,4EAA4E;AAC9E;AACA;EACE,4EAA4E;AAC9E;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oEAAoE;EACpE,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,8BAA8B;EAC9B,uCAAuC;EACvC,iCAAiC;EACjC,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,8BAA8B;EAC9B,yCAAyC;EACzC,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,gDAAgD;AAClD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,SAAO;AACT;AACA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,yCAAyC;AAC3C;AACA;EACE,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uDAAuD;AACzD;AACA;EACE,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,+BAA+B;EAC/B,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,sCAAsC;EACtC,8CAA8C;EAC9C,gBAAgB;EAChB,MAAM;EACN,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,6GAA6G;AAC/G;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;;AAEA;;iDAEiD;;AAEjD;EACE,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B;;;2EAGyE;EACzE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;gFAE8E;EAC9E,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,+FAA+F;EAC/F,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,iCAAiC;EACjC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,iCAAiC;EACjC,2EAA2E;AAC7E;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,iCAAiC;EACjC,qCAAqC;EACrC,yBAAyB;EACzB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qEAAqE;EACrE,cAAc;EACd,0CAA0C;EAC1C,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,6BAA6B;EAC7B,kHAAkH;AACpH;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,yCAAyC;EACzC,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,kJAAkJ;AACpJ;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,iCAAiC;EACjC,yCAAyC;EACzC,qCAAqC;EACrC,2BAA2B;EAC3B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;EAChD,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,yFAAyF;EACzF,yCAAyC;EACzC,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,8FAA8F;EAC9F,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,uEAAuE;EACvE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,iCAAiC;EACjC,qCAAqC;EACrC,yCAAyC;EACzC,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;;;;;EAKE,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;AACrB;;AAEA;;;;;EAKE,+BAA+B;EAC/B,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oHAAoH;AACtH;;AAEA;;;;;EAKE,2BAA2B;EAC3B,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yFAAyF;EACzF,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,yFAAyF;EACzF,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yFAAyF;AAC3F;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;EAC3C,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,yCAAyC;EACzC,mBAAmB;EACnB,4BAA4B;EAC5B,UAAU;EACV,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,8BAA8B;EAC9B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6GAA6G;EAC7G,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,2BAA2B;IAC3B,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF;;AAEA,iBAAiB;AACjB;EACE;;;;;;IAME,aAAa;EACf;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&family=Manrope:wght@400;500;600;700&display=swap');\n\n/* ============================================\n   EDGAR INSIGHTS - MODERN DESIGN SYSTEM\n   ============================================ */\n\n/* CSS Variables */\n:root {\n  /* Colors - Dark Theme */\n  --gray-50: #f9fafb;\n  --gray-100: #f3f4f6;\n  --gray-200: #e5e7eb;\n  --gray-300: #d1d5db;\n  --gray-400: #9ca3af;\n  --gray-500: #6b7280;\n  --gray-600: #4b5563;\n  --gray-700: #374151;\n  --gray-800: #1f2937;\n  --gray-900: #111827;\n  --gray-950: #030712;\n  \n  /* Brand Colors */\n  --gold-400: #fbbf24;\n  --gold-500: #f59e0b;\n  --gold-600: #d97706;\n  \n  --green-400: #34d399;\n  --green-500: #10b981;\n  --green-600: #059669;\n  \n  --red-400: #f87171;\n  --red-500: #ef4444;\n  --red-600: #dc2626;\n  \n  --blue-400: #60a5fa;\n  --blue-500: #3b82f6;\n  --blue-600: #2563eb;\n  \n  /* Background System */\n  --bg-primary: #0a0e1a;\n  --bg-secondary: #0f1419;\n  --bg-tertiary: #1a1f2e;\n  --bg-elevated: #232938;\n  \n  /* Border Colors */\n  --border-primary: rgba(255, 255, 255, 0.08);\n  --border-secondary: rgba(255, 255, 255, 0.12);\n  --border-accent: rgba(251, 191, 36, 0.2);\n  \n  /* Text Colors */\n  --text-primary: #f9fafb;\n  --text-secondary: #d1d5db;\n  --text-tertiary: #9ca3af;\n  --text-muted: #6b7280;\n  \n  /* Spacing Scale */\n  --space-1: 0.25rem;\n  --space-2: 0.5rem;\n  --space-3: 0.75rem;\n  --space-4: 1rem;\n  --space-5: 1.25rem;\n  --space-6: 1.5rem;\n  --space-8: 2rem;\n  --space-10: 2.5rem;\n  --space-12: 3rem;\n  --space-16: 4rem;\n  \n  /* Border Radius */\n  --radius-sm: 0.375rem;\n  --radius-md: 0.5rem;\n  --radius-lg: 0.75rem;\n  --radius-xl: 1rem;\n  --radius-full: 9999px;\n  \n  /* Shadows */\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.3);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.4), 0 2px 4px -1px rgba(0, 0, 0, 0.3);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.5), 0 4px 6px -2px rgba(0, 0, 0, 0.3);\n  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.5), 0 10px 10px -5px rgba(0, 0, 0, 0.3);\n  \n  /* Typography */\n  --font-display: 'Space Grotesk', 'Manrope', -apple-system, 'Segoe UI', 'Helvetica Neue', sans-serif;\n  --font-sans: 'Manrope', -apple-system, 'Segoe UI', 'Helvetica Neue', sans-serif;\n  --font-mono: ui-monospace, 'SF Mono', 'Cascadia Code', 'Source Code Pro', monospace;\n\n  /* Accent */\n  --accent-cyan: #67e8f9;\n  --accent-emerald: #22c55e;\n  --grid-line: rgba(255, 255, 255, 0.04);\n  --glass: rgba(255, 255, 255, 0.04);\n  --glow-amber: 0 16px 70px rgba(245, 158, 11, 0.28);\n  --glow-cyan: 0 16px 70px rgba(103, 232, 249, 0.22);\n  \n  /* Transitions */\n  --transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-base: 200ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-slow: 300ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* ============================================\n   BASE STYLES\n   ============================================ */\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-size-adjust: 100%;\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-family: var(--font-sans);\n  background: var(--bg-primary);\n  color: var(--text-secondary);\n  line-height: 1.6;\n  overflow-x: hidden;\n}\n\nh1, h2, h3, h4 {\n  font-family: var(--font-display);\n  letter-spacing: -0.01em;\n  color: var(--text-primary);\n}\n\np {\n  color: var(--text-secondary);\n}\n\n/* ============================================\n   LAYOUT\n   ============================================ */\n\n.app {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.container {\n  width: 100%;\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 var(--space-6);\n}\n\n.main {\n  flex: 1;\n  padding: var(--space-8) 0;\n}\n\n/* ============================================\n   AUTHENTICATION VIEW\n   ============================================ */\n\n.auth-view {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-6);\n  background: \n    radial-gradient(ellipse 1000px 800px at 30% 20%, rgba(251, 191, 36, 0.08), transparent 50%),\n    radial-gradient(ellipse 800px 600px at 70% 80%, rgba(59, 130, 246, 0.06), transparent 50%),\n    var(--bg-primary);\n}\n\n.auth-container {\n  width: 100%;\n  max-width: 440px;\n}\n\n.auth-brand {\n  text-align: center;\n  margin-bottom: var(--space-8);\n}\n\n.brand-icon {\n  display: inline-flex;\n  margin-bottom: var(--space-4);\n}\n\n.brand-icon-frame {\n  width: 52px;\n  height: 52px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);\n  align-items: center;\n  justify-content: center;\n  padding: 2px;\n  flex-shrink: 0;\n  box-shadow: 0 0 0 2px rgba(251, 191, 36, 0.3);\n}\n\n.brand-icon-frame img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.brand-icon-auth.brand-icon-frame {\n  width: 80px;\n  height: 80px;\n  border-radius: 18px;\n  padding: 4px;\n  margin-bottom: var(--space-4);\n}\n\n.auth-brand h1 {\n  font-size: 1.875rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: var(--space-2);\n  letter-spacing: -0.02em;\n}\n\n.auth-brand p {\n  color: var(--text-tertiary);\n  font-size: 0.9375rem;\n}\n\n.auth-card {\n  background: var(--bg-elevated);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-xl);\n  padding: var(--space-8);\n  box-shadow: var(--shadow-xl);\n}\n\n.auth-tabs {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--space-2);\n  padding: var(--space-1);\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-md);\n  margin-bottom: var(--space-6);\n}\n\n.auth-tabs button {\n  padding: var(--space-2) var(--space-4);\n  background: transparent;\n  border: none;\n  border-radius: var(--radius-sm);\n  color: var(--text-tertiary);\n  font-weight: 600;\n  font-size: 0.9375rem;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.auth-tabs button.active {\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  box-shadow: var(--shadow-sm);\n}\n\n.auth-alert {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-3);\n  padding: var(--space-4);\n  border-radius: var(--radius-md);\n  margin-bottom: var(--space-6);\n  font-size: 0.875rem;\n  line-height: 1.5;\n  min-width: 0;\n}\n\n.auth-alert svg {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.auth-alert .auth-alert-text {\n  min-width: 0;\n  overflow-wrap: break-word;\n  word-break: break-all;\n}\n\n.auth-alert.error {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  color: #fca5a5;\n}\n\n.auth-alert.success {\n  background: rgba(16, 185, 129, 0.1);\n  border: 1px solid rgba(16, 185, 129, 0.3);\n  color: #6ee7b7;\n}\n\n.auth-form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-5);\n}\n\n.form-field {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n}\n\n.form-field label {\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.form-field input,\n.form-field select {\n  width: 100%;\n  padding: var(--space-3) var(--space-4);\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-md);\n  color: var(--text-primary);\n  font-size: 0.9375rem;\n  transition: all var(--transition-fast);\n}\n\n.form-field input:focus,\n.form-field select:focus {\n  outline: none;\n  border-color: var(--gold-500);\n  box-shadow: 0 0 0 3px rgba(251, 191, 36, 0.1);\n}\n\n.form-field input::placeholder {\n  color: var(--text-muted);\n}\n\n.form-actions {\n  display: flex;\n  gap: var(--space-3);\n  margin-top: var(--space-2);\n}\n\n.btn-primary {\n  flex: 1;\n  padding: 0.875rem 1.5rem;\n  background: var(--gold-400);\n  border: none;\n  border-radius: 12px;\n  color: var(--gray-950);\n  font-weight: 600;\n  font-size: 0.9375rem;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: var(--gold-500);\n  box-shadow: 0 4px 14px rgba(251, 191, 36, 0.35);\n  transform: translateY(-1px);\n}\n\n.btn-primary:active:not(:disabled) {\n  transform: translateY(0);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.btn-primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-secondary {\n  flex: 1;\n  padding: 0.875rem 1.5rem;\n  background: transparent;\n  border: 1px solid var(--border-secondary);\n  border-radius: 12px;\n  color: var(--text-primary);\n  font-weight: 600;\n  font-size: 0.9375rem;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, transform 0.15s ease;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: var(--bg-tertiary);\n  border-color: var(--gold-500);\n  color: var(--gold-400);\n  transform: translateY(-1px);\n}\n\n.btn-secondary:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.btn-secondary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.auth-footer {\n  margin-top: var(--space-6);\n  padding-top: var(--space-6);\n  border-top: 1px solid var(--border-primary);\n  display: flex;\n  justify-content: center;\n  gap: var(--space-6);\n}\n\n.link-btn {\n  background: none;\n  border: none;\n  color: var(--gold-400);\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: color var(--transition-fast);\n}\n\n.link-btn:hover {\n  color: var(--gold-500);\n  text-decoration: underline;\n}\n\n/* ============================================\n   HEADER\n   ============================================ */\n\n.header {\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border-primary);\n  backdrop-filter: blur(12px);\n  position: sticky;\n  top: 0;\n  z-index: 50;\n}\n\n.header .brand-icon {\n  margin-bottom: 0;\n}\n\n.header-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--space-4) 0;\n}\n\n.brand {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n}\n\n.brand h1 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  letter-spacing: -0.01em;\n  margin-bottom: 2px;\n}\n\n.brand p {\n  font-size: 0.75rem;\n  color: var(--text-tertiary);\n}\n\n.btn-ghost {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding: var(--space-2) var(--space-4);\n  background: transparent;\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-full);\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.btn-ghost:hover {\n  background: var(--bg-tertiary);\n  border-color: var(--border-secondary);\n  color: var(--text-primary);\n}\n\n.btn-ghost svg {\n  opacity: 0.8;\n}\n\n/* ============================================\n   STATS GRID\n   ============================================ */\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: var(--space-4);\n  margin-bottom: var(--space-8);\n}\n\n.stat-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-lg);\n  padding: var(--space-5);\n  transition: all var(--transition-fast);\n}\n\n.stat-card:hover {\n  border-color: var(--border-secondary);\n  transform: translateY(-2px);\n}\n\n.stat-label {\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: var(--text-tertiary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: var(--space-2);\n}\n\n.stat-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n}\n\n.status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: var(--radius-full);\n  animation: pulse 2s ease-in-out infinite;\n}\n\n.status-running .status-dot {\n  background: var(--green-500);\n}\n\n.status-stopped .status-dot {\n  background: var(--red-500);\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n/* ============================================\n   FILTERS\n   ============================================ */\n\n.filter-section {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-lg);\n  padding: var(--space-6);\n  margin-bottom: var(--space-8);\n}\n\n.filter-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: var(--space-4);\n}\n\n.filter-field {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n}\n\n.filter-field label {\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: var(--text-tertiary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.filter-field input,\n.filter-field select {\n  width: 100%;\n  padding: var(--space-3) var(--space-4);\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-lg);\n  color: var(--text-primary);\n  font-size: 0.9375rem;\n  font-weight: 500;\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast), background var(--transition-fast);\n}\n\n.filter-field input:hover,\n.filter-field select:hover {\n  border-color: var(--border-secondary);\n  background: var(--bg-secondary);\n}\n\n.filter-field input:focus,\n.filter-field select:focus {\n  outline: none;\n  border-color: var(--gold-500);\n  box-shadow: 0 0 0 3px rgba(251, 191, 36, 0.12);\n  background: var(--bg-secondary);\n}\n\n.filter-field select {\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right var(--space-4) center;\n  padding-right: var(--space-10);\n}\n\n.filter-field-checkbox {\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n}\n.filter-field-checkbox label {\n  order: 2;\n  margin-left: var(--space-2);\n  text-transform: none;\n  letter-spacing: 0;\n}\n.filter-field-checkbox input[type=\"checkbox\"] {\n  width: auto;\n  order: 1;\n  accent-color: var(--gold-500);\n  cursor: pointer;\n}\n\n.ticker-search-wrapper {\n  position: relative;\n}\n\n.search-icon {\n  position: absolute;\n  left: var(--space-4);\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-muted);\n  pointer-events: none;\n}\n\n.ticker-search-wrapper input {\n  padding-left: var(--space-10);\n}\n\n.dropdown {\n  position: absolute;\n  top: calc(100% + var(--space-2));\n  left: 0;\n  right: 0;\n  background: var(--bg-elevated);\n  border: 1px solid var(--border-secondary);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  max-height: 300px;\n  overflow-y: auto;\n  z-index: 100;\n}\n\n.dropdown-item {\n  width: 100%;\n  padding: var(--space-3) var(--space-4);\n  background: transparent;\n  border: none;\n  border-bottom: 1px solid var(--border-primary);\n  text-align: left;\n  cursor: pointer;\n  transition: background var(--transition-fast), color var(--transition-fast);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-4);\n  font-size: 0.9375rem;\n}\n\n.dropdown-item:last-child {\n  border-bottom: none;\n}\n\n.dropdown-item:hover {\n  background: rgba(251, 191, 36, 0.08);\n}\n\n.dropdown-item:hover .ticker-symbol {\n  color: var(--gold-400);\n}\n\n.ticker-symbol {\n  font-weight: 700;\n  color: var(--gold-400);\n  font-size: 0.9375rem;\n}\n\n.ticker-name {\n  color: var(--text-tertiary);\n  font-size: 0.875rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.filter-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding: var(--space-2) var(--space-4);\n  background: rgba(251, 191, 36, 0.1);\n  border: 1px solid rgba(251, 191, 36, 0.3);\n  border-radius: var(--radius-full);\n  color: var(--gold-400);\n  font-size: 0.875rem;\n  font-weight: 600;\n  margin-top: var(--space-2);\n}\n\n.filter-tag button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  margin-left: var(--space-1);\n  background: transparent;\n  border: none;\n  border-radius: 50%;\n  color: var(--text-muted);\n  font-size: 1.125rem;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0;\n  transition: color var(--transition-fast), background var(--transition-fast);\n}\n\n.filter-tag button:hover {\n  color: var(--red-500);\n  background: rgba(239, 68, 68, 0.15);\n}\n\n/* ============================================\n   CONTENT SECTIONS\n   ============================================ */\n\n.content-section {\n  margin-top: var(--space-6);\n}\n\n.section-header {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  margin-bottom: var(--space-6);\n}\n\n.section-header h2 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  letter-spacing: -0.02em;\n}\n\n.count-badge {\n  padding: var(--space-1) var(--space-3);\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-full);\n  color: var(--text-tertiary);\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n/* ============================================\n   ALERTS\n   ============================================ */\n\n.alert {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-4);\n  padding: var(--space-4);\n  border-radius: var(--radius-lg);\n  margin-bottom: var(--space-6);\n}\n\n.alert svg {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.alert-error {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  color: #fca5a5;\n}\n\n.alert strong {\n  display: block;\n  color: var(--text-primary);\n  margin-bottom: var(--space-1);\n  font-weight: 600;\n}\n\n.alert p {\n  font-size: 0.875rem;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.btn-sm {\n  padding: var(--space-2) var(--space-4);\n  background: rgba(239, 68, 68, 0.2);\n  border: 1px solid rgba(239, 68, 68, 0.4);\n  border-radius: var(--radius-md);\n  color: #fca5a5;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  margin-left: auto;\n}\n\n.btn-sm:hover {\n  background: rgba(239, 68, 68, 0.3);\n}\n\n/* ============================================\n   STATES\n   ============================================ */\n\n.loading-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-16) var(--space-6);\n  text-align: center;\n}\n\n.spinner-large {\n  width: 48px;\n  height: 48px;\n  border: 4px solid var(--bg-tertiary);\n  border-top-color: var(--gold-500);\n  border-radius: var(--radius-full);\n  animation: spin 1s linear infinite;\n  margin-bottom: var(--space-4);\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.loading-state p {\n  color: var(--text-tertiary);\n  font-size: 0.9375rem;\n}\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-16) var(--space-6);\n  text-align: center;\n}\n\n.empty-state svg {\n  color: var(--text-muted);\n  margin-bottom: var(--space-6);\n  opacity: 0.5;\n}\n\n.empty-state h3 {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: var(--space-2);\n}\n\n.empty-state p {\n  color: var(--text-tertiary);\n  font-size: 0.9375rem;\n}\n\n/* ============================================\n   SIGNAL CARDS\n   ============================================ */\n\n.cards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));\n  gap: var(--space-6);\n}\n\n.signal-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  transition: all var(--transition-base);\n}\n\n.signal-card:hover {\n  border-color: var(--border-secondary);\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-lg);\n}\n\n.signal-card.has-trade {\n  border-color: var(--border-accent);\n  cursor: pointer;\n}\n\n.signal-card.has-trade.trade-decision-yes {\n  box-shadow: 0 0 0 1px rgba(16, 185, 129, 0.4), 0 0 20px rgba(16, 185, 129, 0.15);\n}\n.signal-card.has-trade.trade-decision-yes:hover {\n  box-shadow: 0 0 0 1px rgba(16, 185, 129, 0.5), 0 0 24px rgba(16, 185, 129, 0.25);\n}\n\n.signal-card.has-trade.trade-decision-no {\n  box-shadow: 0 0 0 1px rgba(255, 69, 0, 0.4), 0 0 20px rgba(255, 69, 0, 0.15);\n}\n.signal-card.has-trade.trade-decision-no:hover {\n  box-shadow: 0 0 0 1px rgba(255, 69, 0, 0.5), 0 0 24px rgba(255, 69, 0, 0.25);\n}\n\n.signal-card.expanded {\n  grid-column: 1 / -1;\n}\n\n.card-main {\n  padding: var(--space-6);\n}\n\n.card-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: var(--space-4);\n  margin-bottom: var(--space-5);\n}\n\n.ticker-info h3 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--gold-400);\n  letter-spacing: -0.01em;\n  margin-bottom: var(--space-1);\n}\n\n.ticker-info p {\n  font-size: 0.875rem;\n  color: var(--text-tertiary);\n  line-height: 1.4;\n}\n\n.signal-badge {\n  padding: var(--space-2) var(--space-4);\n  border-radius: var(--radius-full);\n  font-size: 0.8125rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  white-space: nowrap;\n}\n\n.signal-buy {\n  background: rgba(16, 185, 129, 0.15);\n  color: var(--green-400);\n  border: 1px solid rgba(16, 185, 129, 0.3);\n}\n\n.signal-sell {\n  background: rgba(239, 68, 68, 0.15);\n  color: var(--red-400);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n}\n\n.signal-hold {\n  background: rgba(251, 191, 36, 0.15);\n  color: var(--gold-400);\n  border: 1px solid rgba(251, 191, 36, 0.3);\n}\n\n.card-metrics {\n  display: grid;\n  gap: var(--space-4);\n  margin-bottom: var(--space-5);\n  padding-bottom: var(--space-5);\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.metric {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-4);\n}\n\n.metric-label {\n  font-size: 0.8125rem;\n  color: var(--text-tertiary);\n  font-weight: 500;\n}\n\n.metric-value {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  font-size: 0.9375rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.confidence-bar {\n  width: 120px;\n  height: 6px;\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-full);\n  overflow: hidden;\n}\n\n.confidence-fill {\n  height: 100%;\n  background: linear-gradient(90deg, var(--gold-500), var(--gold-400));\n  border-radius: var(--radius-full);\n  transition: width var(--transition-slow);\n}\n\n.sentiment-badge {\n  padding: var(--space-1) var(--space-3);\n  border-radius: var(--radius-full);\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.sentiment-bullish {\n  background: rgba(16, 185, 129, 0.15);\n  color: var(--green-400);\n}\n\n.sentiment-bearish {\n  background: rgba(239, 68, 68, 0.15);\n  color: var(--red-400);\n}\n\n.sentiment-neutral {\n  background: rgba(251, 191, 36, 0.15);\n  color: var(--gold-400);\n}\n\n.key-insights {\n  margin-bottom: var(--space-5);\n}\n\n.key-insights h4 {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: var(--space-3);\n}\n\n.key-insights ul {\n  list-style: none;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n}\n\n.key-insights li {\n  position: relative;\n  padding-left: var(--space-5);\n  font-size: 0.875rem;\n  line-height: 1.6;\n  color: var(--text-tertiary);\n}\n\n.key-insights li::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 8px;\n  width: 6px;\n  height: 6px;\n  background: var(--gold-500);\n  border-radius: var(--radius-full);\n}\n\n.card-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-4);\n  padding-top: var(--space-4);\n  border-top: 1px solid var(--border-primary);\n}\n\n.meta {\n  display: flex;\n  align-items: center;\n  gap: var(--space-4);\n  flex-wrap: wrap;\n}\n\n.meta-item {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  font-size: 0.8125rem;\n  color: var(--text-muted);\n}\n\n.meta-item svg {\n  opacity: 0.6;\n}\n\n.expand-trigger {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding: var(--space-2) var(--space-4);\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-full);\n  color: var(--text-secondary);\n  font-size: 0.8125rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  white-space: nowrap;\n}\n\n.expand-trigger:hover {\n  background: var(--bg-elevated);\n  border-color: var(--border-accent);\n  color: var(--gold-400);\n}\n\n.expand-trigger svg {\n  transition: transform var(--transition-base);\n}\n\n.card-expanded {\n  background: var(--bg-tertiary);\n  border-top: 1px solid var(--border-primary);\n  padding: var(--space-6);\n}\n\n.expanded-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: var(--space-6);\n}\n\n.info-section h4 {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: var(--space-4);\n}\n\n.info-section dl {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n.info-section dl > div {\n  display: grid;\n  grid-template-columns: 120px 1fr;\n  gap: var(--space-4);\n  align-items: start;\n  padding-bottom: var(--space-4);\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.info-section dl > div:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.info-section dt {\n  font-size: 0.8125rem;\n  color: var(--text-muted);\n  font-weight: 500;\n}\n\n.info-section dd {\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n  margin: 0;\n  word-break: break-word;\n}\n\n.info-section a {\n  color: var(--gold-400);\n  text-decoration: none;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-2);\n  transition: color var(--transition-fast);\n}\n\n.info-section a:hover {\n  color: var(--gold-500);\n  text-decoration: underline;\n}\n\n.info-section a svg {\n  opacity: 0.7;\n}\n\n.badge {\n  display: inline-block;\n  padding: var(--space-1) var(--space-3);\n  background: var(--bg-elevated);\n  border: 1px solid var(--border-secondary);\n  border-radius: var(--radius-full);\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.text-muted {\n  color: var(--text-muted);\n}\n\n.text-mono {\n  font-family: var(--font-mono);\n  font-size: 0.8125rem;\n}\n\n.trade-events-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  font-size: 0.8125rem;\n}\n.trade-events-list li {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: var(--space-2);\n  padding: var(--space-2) 0;\n  border-bottom: 1px solid var(--border-secondary);\n}\n.trade-events-list li:last-child {\n  border-bottom: none;\n}\n.trade-events-list .event-type {\n  font-weight: 600;\n  color: var(--text-primary);\n  min-width: 8rem;\n}\n.trade-events-list .event-message {\n  color: var(--text-secondary);\n  flex: 1;\n}\n.trade-events-list .event-time {\n  color: var(--text-muted);\n  font-size: 0.75rem;\n}\n.info-section .trade-reasoning {\n  white-space: pre-wrap;\n  max-height: 8rem;\n  overflow-y: auto;\n}\n\n.trade-reasoning-full {\n  grid-column: 1 / -1;\n  margin-top: var(--space-6);\n  padding: var(--space-5);\n  background: var(--bg-elevated);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-secondary);\n}\n.trade-reasoning-full p {\n  margin: 0;\n  font-size: 0.9375rem;\n  line-height: 1.65;\n  color: var(--text-secondary);\n  white-space: pre-wrap;\n}\n\n.trade-details-block {\n  grid-column: 1 / -1;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-8);\n  padding: var(--space-2) 0 var(--space-2) var(--space-5);\n}\n.trade-details-block.trade-decision-yes {\n  border-left: 3px solid #10b981;\n  margin-left: 0;\n}\n.trade-details-block.trade-decision-no {\n  border-left: 3px solid #ff4500;\n  margin-left: 0;\n}\n.trade-details-block .info-section {\n  margin-bottom: 0;\n}\n.trade-details-block .info-section h4 {\n  margin-bottom: var(--space-5);\n}\n.trade-details-block .info-section dl {\n  gap: var(--space-4);\n}\n.trade-details-block .info-section dl > div {\n  padding-bottom: var(--space-4);\n}\n.trade-details-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--space-8);\n  align-items: start;\n}\n.trade-details-col {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-8);\n  min-width: 0;\n}\n.trade-details-row:not(:has(.trade-details-left .info-section)) .trade-details-right {\n  grid-column: 1 / -1;\n}\n\n.trade-details-block .trade-events-list {\n  margin-top: var(--space-2);\n}\n.trade-details-block .trade-events-list li {\n  padding: var(--space-3) 0;\n}\n\n@media (max-width: 700px) {\n  .trade-details-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Trade detail modal (pop-out viewbox) */\n.trade-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: var(--space-6);\n  animation: fadeIn 0.2s ease-out;\n}\n\n.trade-modal-viewbox {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-lg);\n  max-width: 640px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-x: hidden;\n  overflow-y: auto;\n  box-shadow: var(--shadow-xl);\n  animation: slideUp 0.25s ease-out;\n}\n\n@media (min-width: 880px) {\n  .trade-modal-viewbox {\n    max-width: 900px;\n  }\n}\n\n.trade-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-4);\n  padding: var(--space-5) var(--space-6);\n  border-bottom: 1px solid var(--border-primary);\n  position: sticky;\n  top: 0;\n  background: var(--bg-secondary);\n  z-index: 1;\n}\n\n.trade-modal-header h2 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--gold-400);\n  margin: 0;\n}\n\n.trade-modal-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border: none;\n  background: var(--bg-tertiary);\n  border-radius: 50%;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: color var(--transition-fast), background var(--transition-fast), transform var(--transition-fast);\n}\n\n.trade-modal-close:hover {\n  color: var(--text-primary);\n  background: var(--border-secondary);\n  transform: scale(1.05);\n}\n\n.trade-modal-close:active {\n  transform: scale(0.98);\n}\n\n.trade-modal-body {\n  padding: var(--space-8);\n}\n.trade-modal-body .expanded-grid {\n  gap: var(--space-8);\n}\n.trade-modal-body .info-section h4 {\n  margin-bottom: var(--space-5);\n}\n.trade-modal-body .info-section dl > div {\n  padding-bottom: var(--space-4);\n  gap: var(--space-4);\n}\n.trade-modal-body .info-section:first-of-type dl > div {\n  padding-bottom: var(--space-4);\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.card-click-hint {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  margin-left: auto;\n}\n\n.alpaca-order-link {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-1);\n  color: var(--gold-400);\n  text-decoration: none;\n  font-family: var(--font-mono);\n  font-size: 0.8125rem;\n}\n.alpaca-order-link:hover {\n  color: var(--gold-500);\n  text-decoration: underline;\n}\n.alpaca-order-link svg {\n  opacity: 0.8;\n}\n\n/* ============================================\n   LANDING PAGE\n   ============================================ */\n\n.landing {\n  position: relative;\n  min-height: 100vh;\n  color: var(--text-primary);\n  background:\n    radial-gradient(1200px 700px at 12% 12%, rgba(103, 232, 249, 0.08), transparent 40%),\n    radial-gradient(900px 600px at 78% 8%, rgba(245, 158, 11, 0.12), transparent 40%),\n    linear-gradient(180deg, rgba(15, 20, 25, 0.94), rgba(10, 14, 26, 0.98));\n  overflow: hidden;\n}\n\n.landing::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background:\n    linear-gradient(90deg, var(--grid-line) 1px, transparent 1px) 0 0 / 80px 80px,\n    linear-gradient(0deg, var(--grid-line) 1px, transparent 1px) 0 0 / 80px 80px;\n  opacity: 0.45;\n  pointer-events: none;\n}\n\n.landing::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(650px 650px at 65% 35%, rgba(255, 255, 255, 0.06), transparent 60%);\n  mix-blend-mode: screen;\n  pointer-events: none;\n}\n\n.landing-inner {\n  position: relative;\n  z-index: 1;\n}\n\n.landing-header {\n  position: sticky;\n  top: 0;\n  z-index: 60;\n  background: rgba(10, 14, 26, 0.8);\n  backdrop-filter: blur(16px);\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.landing-nav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-6);\n  padding: var(--space-4) var(--space-4);\n}\n\n.nav-brand {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n}\n\n.nav-brand .brand-icon-frame {\n  box-shadow: var(--glow-amber);\n}\n\n.nav-title {\n  font-size: 1rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--text-tertiary);\n}\n\n.nav-links {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-6);\n  list-style: none;\n  flex: 1;\n}\n\n.nav-links a {\n  color: var(--text-secondary);\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 0.95rem;\n  padding: var(--space-2) var(--space-3);\n  border-radius: var(--radius-full);\n  transition: color var(--transition-fast), background var(--transition-fast);\n}\n\n.nav-links a:hover {\n  color: var(--gold-400);\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.nav-actions {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n}\n\n.pill {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding: var(--space-2) var(--space-3);\n  border-radius: var(--radius-full);\n  background: rgba(103, 232, 249, 0.12);\n  color: var(--accent-cyan);\n  border: 1px solid rgba(103, 232, 249, 0.3);\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.cta-button {\n  background: linear-gradient(120deg, var(--gold-400), var(--gold-500));\n  color: #0b0f1a;\n  border: 1px solid rgba(251, 191, 36, 0.45);\n  border-radius: 14px;\n  padding: var(--space-3) var(--space-5);\n  font-weight: 700;\n  font-size: 0.95rem;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  box-shadow: var(--glow-amber);\n  transition: transform var(--transition-fast), box-shadow var(--transition-fast), background var(--transition-fast);\n}\n\n.cta-button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 12px 30px rgba(251, 191, 36, 0.35);\n}\n\n.cta-button:active {\n  transform: translateY(0);\n}\n\n.cta-secondary {\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--text-primary);\n  border: 1px solid var(--border-secondary);\n  border-radius: 14px;\n  padding: var(--space-3) var(--space-5);\n  font-weight: 700;\n  cursor: pointer;\n  transition: background var(--transition-fast), border-color var(--transition-fast), color var(--transition-fast), transform var(--transition-fast);\n}\n\n.cta-secondary:hover {\n  background: var(--bg-tertiary);\n  border-color: var(--border-accent);\n  color: var(--gold-400);\n  transform: translateY(-1px);\n}\n\n.hero {\n  position: relative;\n  padding: var(--space-16) 0 var(--space-12);\n  z-index: 1;\n}\n\n.hero-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: var(--space-10);\n  align-items: center;\n}\n\n.hero-copy {\n  max-width: 720px;\n  display: grid;\n  gap: var(--space-4);\n}\n\n.hero-eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding: var(--space-2) var(--space-3);\n  border-radius: var(--radius-full);\n  border: 1px solid var(--border-secondary);\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--text-tertiary);\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  width: fit-content;\n}\n\n.hero-title {\n  font-size: clamp(2.4rem, 2.2vw + 1.2rem, 3.6rem);\n  line-height: 1.05;\n  color: var(--text-primary);\n}\n\n.hero-title span {\n  color: var(--gold-400);\n}\n\n.hero-lede {\n  font-size: 1.05rem;\n  color: var(--text-secondary);\n  max-width: 640px;\n}\n\n.hero-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-3);\n  align-items: center;\n}\n\n.hero-footnote {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  color: var(--text-tertiary);\n  font-size: 0.85rem;\n}\n\n.site-tagline {\n  text-align: center;\n  color: var(--text-tertiary);\n  font-size: 0.85rem;\n  margin-top: var(--space-2);\n  margin-bottom: 0;\n}\n\n.disclaimer {\n  margin-top: var(--space-1);\n  text-align: center;\n  font-size: 0.72rem;\n  color: var(--text-quaternary, #7f8899);\n  line-height: 1.4;\n}\n\n.hero-panel {\n  background: linear-gradient(145deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.02));\n  border: 1px solid var(--border-secondary);\n  border-radius: 18px;\n  padding: var(--space-6);\n  box-shadow: var(--glow-cyan);\n  position: relative;\n  overflow: hidden;\n}\n\n.hero-panel::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(400px 400px at 80% 20%, rgba(103, 232, 249, 0.2), transparent 55%);\n  pointer-events: none;\n}\n\n.hero-panel h3 {\n  font-size: 1rem;\n  color: var(--text-tertiary);\n  margin-bottom: var(--space-3);\n}\n\n.hero-panel .panel-metric {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  padding: var(--space-3) 0;\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.hero-panel .panel-metric:last-child {\n  border-bottom: none;\n}\n\n.panel-metric strong {\n  font-size: 1.4rem;\n  color: var(--text-primary);\n}\n\n.panel-metric span {\n  color: var(--text-tertiary);\n  font-size: 0.9rem;\n}\n\n.hero-meter {\n  margin-top: var(--space-4);\n  position: relative;\n  height: 12px;\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-full);\n  overflow: hidden;\n}\n\n.hero-meter-fill {\n  width: 82%;\n  height: 100%;\n  background: linear-gradient(90deg, var(--gold-500), var(--accent-cyan));\n  box-shadow: var(--glow-amber);\n}\n\n.hero-meter-label {\n  position: absolute;\n  top: 50%;\n  right: var(--space-3);\n  transform: translateY(-50%);\n  font-size: 0.75rem;\n  color: var(--text-primary);\n  letter-spacing: 0.06em;\n}\n\n.hero-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: var(--space-3);\n  margin-top: var(--space-5);\n}\n\n.hero-stat {\n  padding: var(--space-4);\n  background: var(--bg-secondary);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border-secondary);\n  display: grid;\n  gap: var(--space-1);\n  box-shadow: var(--shadow-md);\n}\n\n.hero-stat .label {\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--text-tertiary);\n}\n\n.hero-stat .value {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.section {\n  padding: var(--space-12) 0;\n  position: relative;\n  z-index: 1;\n}\n\n.section-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: var(--space-6);\n  margin-bottom: var(--space-6);\n  flex-wrap: wrap;\n}\n\n.section-eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding: var(--space-2) var(--space-3);\n  border-radius: var(--radius-full);\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid var(--border-secondary);\n  color: var(--text-tertiary);\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  font-weight: 700;\n  font-size: 0.8rem;\n}\n\n.section-title {\n  font-size: 2rem;\n  margin-top: var(--space-2);\n}\n\n.section-description {\n  max-width: 760px;\n  color: var(--text-secondary);\n  font-size: 1rem;\n}\n\n.about-grid,\n.feature-grid,\n.pricing-grid,\n.blog-grid,\n.faq-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: var(--space-5);\n}\n\n.about-card,\n.feature-card,\n.pricing-card,\n.blog-card,\n.faq-item {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-lg);\n  padding: var(--space-5);\n  position: relative;\n  overflow: hidden;\n  transition: transform var(--transition-fast), border-color var(--transition-fast), box-shadow var(--transition-fast);\n}\n\n.about-card:hover,\n.feature-card:hover,\n.pricing-card:hover,\n.blog-card:hover,\n.faq-item:hover {\n  transform: translateY(-4px);\n  border-color: var(--border-secondary);\n  box-shadow: var(--shadow-lg);\n}\n\n.about-card h3 {\n  margin-bottom: var(--space-2);\n}\n\n.about-card p {\n  color: var(--text-secondary);\n}\n\n.feature-card {\n  background: linear-gradient(150deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.01));\n  border: 1px solid var(--border-secondary);\n}\n\n.feature-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(251, 191, 36, 0.12);\n  color: var(--gold-400);\n  margin-bottom: var(--space-3);\n}\n\n.feature-card ul {\n  list-style: none;\n  padding: 0;\n  margin: var(--space-3) 0 0;\n  display: grid;\n  gap: var(--space-2);\n}\n\n.feature-card li {\n  color: var(--text-secondary);\n  font-size: 0.95rem;\n  display: flex;\n  gap: var(--space-2);\n  align-items: baseline;\n}\n\n.feature-card li::before {\n  content: '+';\n  color: var(--accent-cyan);\n  font-weight: 700;\n}\n\n.pricing-grid {\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n}\n\n.pricing-card {\n  background: linear-gradient(150deg, rgba(255, 255, 255, 0.02), rgba(103, 232, 249, 0.04));\n  border: 1px solid var(--border-primary);\n}\n\n.pricing-card.recommended {\n  border: 1px solid rgba(251, 191, 36, 0.6);\n  box-shadow: var(--glow-amber);\n}\n\n.pricing-card .plan-label {\n  display: none;\n}\n\n.pricing-card .price {\n  font-size: 2.4rem;\n  font-weight: 700;\n  margin: var(--space-3) 0 var(--space-1);\n  color: var(--text-primary);\n}\n\n.pricing-card .price small {\n  font-size: 1rem;\n  color: var(--text-tertiary);\n  font-weight: 500;\n}\n\n.pricing-card .price-note {\n  color: var(--text-tertiary);\n  margin-bottom: var(--space-4);\n}\n\n.pricing-card .plan-features {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 var(--space-5);\n  display: grid;\n  gap: var(--space-2);\n}\n\n.pricing-card .plan-features li {\n  display: flex;\n  gap: var(--space-2);\n  align-items: center;\n  color: var(--text-secondary);\n  font-size: 0.95rem;\n}\n\n.pricing-card .plan-features li::before {\n  content: '+';\n  color: var(--gold-400);\n  font-weight: 800;\n}\n\n.blog-card {\n  background: linear-gradient(165deg, rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0.01));\n}\n\n.blog-card .meta {\n  display: flex;\n  gap: var(--space-3);\n  color: var(--text-tertiary);\n  font-size: 0.85rem;\n  margin-bottom: var(--space-2);\n}\n\n.blog-card h3 {\n  margin-bottom: var(--space-2);\n}\n\n.blog-card a {\n  color: var(--gold-400);\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.blog-card a:hover {\n  text-decoration: underline;\n}\n\n.faq-item {\n  display: grid;\n  gap: var(--space-2);\n}\n\n.faq-item h4 {\n  margin: 0;\n}\n\n.faq-item p {\n  margin: 0;\n  color: var(--text-secondary);\n}\n\n.landing-footer {\n  padding: var(--space-6) 0 var(--space-4);\n  border-top: 1px solid var(--border-primary);\n  margin-top: var(--space-3);\n  color: var(--text-tertiary);\n  font-size: 0.95rem;\n}\n\n/* Auth overlay */\n.auth-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: grid;\n  place-items: center;\n  padding: var(--space-4);\n}\n\n.auth-overlay__backdrop {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(6px);\n}\n\n.auth-overlay__panel {\n  position: relative;\n  width: min(920px, calc(100vw - 2rem));\n  max-height: 92vh;\n  overflow-y: auto;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-secondary);\n  border-radius: 18px;\n  box-shadow: var(--shadow-xl);\n  z-index: 1;\n  padding: var(--space-2) var(--space-2) var(--space-4);\n}\n\n.auth-overlay__close {\n  position: absolute;\n  top: var(--space-3);\n  right: var(--space-3);\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 1px solid var(--border-primary);\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform var(--transition-fast), background var(--transition-fast), color var(--transition-fast);\n  z-index: 2;\n}\n\n.auth-overlay__close:hover {\n  color: var(--gold-400);\n  background: var(--bg-secondary);\n  transform: translateY(-1px);\n}\n\n.auth-overlay .auth-view {\n  min-height: auto;\n  background: transparent;\n  padding: var(--space-2);\n}\n\n.auth-overlay .auth-container {\n  max-width: 640px;\n  margin: 0 auto;\n}\n\n.auth-overlay .auth-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-secondary);\n  box-shadow: var(--shadow-lg);\n}\n\n/* ============================================\n   RESPONSIVE DESIGN\n   ============================================ */\n\n@media (max-width: 768px) {\n  .container {\n    padding: 0 var(--space-4);\n  }\n  \n  .main {\n    padding: var(--space-6) 0;\n  }\n  \n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .filter-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .cards-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .signal-card.expanded {\n    grid-column: auto;\n  }\n  \n  .expanded-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .auth-footer {\n    flex-direction: column;\n    gap: var(--space-3);\n  }\n  \n  .brand h1 {\n    font-size: 1.125rem;\n  }\n  \n  .brand p {\n    display: none;\n  }\n  \n  .info-section dl > div {\n    grid-template-columns: 1fr;\n    gap: var(--space-1);\n  }\n\n  .landing-nav {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--space-3);\n  }\n\n  .nav-links {\n    width: 100%;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    gap: var(--space-3);\n  }\n\n  .nav-actions {\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .hero {\n    padding: var(--space-12) 0 var(--space-8);\n  }\n\n  .hero-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .hero-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .cta-button,\n  .cta-secondary {\n    width: 100%;\n    text-align: center;\n  }\n\n  .section-heading {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 480px) {\n  .header-content {\n    flex-wrap: wrap;\n  }\n  \n  .btn-ghost span {\n    display: none;\n  }\n  \n  .meta {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--space-2);\n  }\n  \n  .card-footer {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .nav-links {\n    overflow-x: auto;\n    width: 100%;\n    padding-bottom: var(--space-2);\n  }\n  \n  .nav-links a {\n    white-space: nowrap;\n  }\n  \n  .hero-panel {\n    padding: var(--space-5);\n  }\n}\n\n/* Accessibility */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n/* Print styles */\n@media print {\n  .header,\n  .filter-section,\n  .btn-primary,\n  .btn-secondary,\n  .btn-ghost,\n  .expand-trigger {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
